import { Component, Inject, Injector, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { BaseComponent } from 'src/app/shared/base/base.component';
import { NewAppAlertPopupComponent } from './new-app-alert-popup/new-app-alert-popup.component';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-new-app-alert',
  templateUrl: './new-app-alert.component.html',
  providers: [
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} },
  ],
})
export class NewAppAlertComponent extends BaseComponent implements OnInit {
  constructor(
    injector: Injector,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    public router: Router
  ) {
    super(injector);
  }

  ngOnInit(): void {
    if (this.route.snapshot.queryParamMap.get('new_app_alert') === 'true') {
      this.dialog.open(NewAppAlertPopupComponent, { data: {} });
      this.router.navigate([], {
        queryParams: {
          new_app_alert: null,
        },
        queryParamsHandling: 'merge',
        replaceUrl: true,
      });
    }
  }
}
